"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var TabGroup_styles_1 = require("./TabGroup.styles");
/** A group of tabs. Note, only supports 2 tabs.  */
function TabGroup(_a) {
    var activeTabIndex = _a.activeTabIndex, onTabChange = _a.onTabChange, tabs = _a.tabs;
    return (react_1.default.createElement(TabGroup_styles_1.STabs, null, tabs.map(function (tab, index) {
        var dataTestId = tab.replace(/\s/g, '').toLowerCase() + 'Tab';
        var key = dataTestId + index;
        return (react_1.default.createElement(TabGroup_styles_1.STab, { type: "button", key: key, "data-testId": dataTestId, onClick: function (e) {
                e.preventDefault();
                onTabChange(index);
            }, className: activeTabIndex === index ? 'active' : '' }, tab));
    })));
}
exports.default = TabGroup;
//# sourceMappingURL=TabGroup.js.map